<ion-app>
    <ion-router-outlet></ion-router-outlet>
    <div *ngIf="!connected" class="offline-wrapper">
        <span>Offline</span>
    </div>
</ion-app>
